import { List, Map } from "immutable";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getImage } from "data/assets";

import { nextPage, setCurrentPage } from "data/voting-form/routes";
import {
  getAutoVote,
  getAvailableVotes,
  getDonationId,
  getSelectedCampaigns,
  getTotalVotes,
  getVotingUserId,
  resetSearchFilters,
  setAutoVote,
  submitVotes,
} from "data/voting-form/voting";

import { getCampaign as getParentCampaign } from "data/parent-campaign";

export class ThankYou extends React.Component {
  static propTypes = {
    voteBox: PropTypes.string.isRequired,
    availableVotes: PropTypes.number.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
  };

  state = {
    loading: false,
  };

  handleCloseModal = () => {
    const { onCloseModal } = this.props;

    onCloseModal();
  };

  handleNextPage = () => {
    const { nextPage, resetSearchFilters } = this.props;

    nextPage();
    resetSearchFilters();
  };

  handleAutoVote = () => {
    const { setAutoVote, autoVote } = this.props;

    setAutoVote(!autoVote);
  };

  submitVotes = (e) => {
    const { donationId, setCurrentPage, submitVotes, userId, campaign, totalVotes } =
      this.props;
    e.preventDefault;

    const campaignWithVotes = campaign.set("votes", totalVotes);

    this.setState({
      loading: true,
    });

    submitVotes({
      donationId,
      userId,
      parentCampaignId: campaign.get("id"),
      campaigns: List([campaignWithVotes]),
    }).then(
      () => {
        this.setState({
          loading: false,
        });
        setCurrentPage("finish");
      },
      () => {
        this.setState({
          loading: false,
        });
      },
    );
  };

  componentDidMount() {
    window &&
      window.SnapAnalytics &&
      window.SnapAnalytics.track({
        hitType: "event",
        eventCategory: "giving form",
        eventAction: "donationFormThankYou",
      });
  }

  renderButton() {
    const { autoVote } = this.props;
    const { loading } = this.state;

    if (autoVote) {
      return (
        <button
          data-testid="t-voting-form--ThankYo-button"
          className="voting-modal-btn secondary-color-background"
          disabled={loading}
          onClick={this.submitVotes}>
          {loading ? <i className="fa fa-spin fa-refresh" /> : "Vote Now"}
        </button>
      );
    } else {
      return (
        <button
          data-testid="t-voting-form--ThankYo-button-2"
          className="voting-modal-btn secondary-color-background"
          onClick={this.handleNextPage}>
          Vote Now
        </button>
      );
    }
  }

  render() {
    const { autoVote, availableVotes, campaign, voteBox } = this.props;

    return (
      <section className="voting-modal primary-color-background">
        <div className="voting-modal-background">
          <button
            data-testid="t-voting-form--ThankYo-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button secondary-color-text"
            onClick={this.handleCloseModal}>
            <i className="fa fa-times fa-2x"></i>
          </button>
          <div className="p-md-b">
            <h2 className="voting-modal-header">
              Give &gt; <span className="step-active secondary-color-text">Vote</span>{" "}
              &gt; Watch
            </h2>
            <span className="white-font-color">
              Thank you for your gift, now it’s time to cast your votes.
            </span>
          </div>
          <div className="voting-modal-body">
            <div className="voting-modal-body-inside">
              <div className="donating-amount-area">
                <div className="after_donating clearfix">
                  <div className="flex-it text-left">
                    <img src={voteBox} />
                    <div className="m-md-r">
                      <div className="after_donating_title primary-color-text">
                        YOU HAVE {availableVotes || 0} VOTE
                        {availableVotes == 1 ? "" : "S"} AVAILABLE!
                      </div>
                      <span className="after_donating_message">
                        Click 'Vote Now' and see the impact of your gift!
                      </span>
                    </div>
                  </div>
                  <div className="after_donating_box">
                    <span className="primary-color-text">{availableVotes || 0}</span>
                    <br />
                    <span className="after_donating_remaining">Votes</span>
                  </div>
                </div>
              </div>
              <div className="horizontal-line"></div>
              <i
                className="fa fa-gift fa-4x m-sm-r primary-color-text"
                style={{ verticalAlign: "top" }}></i>
              <span className="directions">
                Thank you for your gift - now it's time to cast your votes!
                <br />
                <br />
                <label style={{ textTransform: "none" }}>
                  {" "}
                  <input
                    data-testid="t-voting-form--ThankYo-checkbox"
                    checked={autoVote}
                    onChange={this.handleAutoVote}
                    type="checkbox"
                    style={{ verticalAlign: "top" }}
                  />
                  &nbsp;Cast my votes to {campaign.get("name")}.
                </label>
              </span>
              <div></div>
            </div>
          </div>
          {this.renderButton()}
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    availableVotes: getAvailableVotes(state),
    campaign: getParentCampaign(state)("voting_form"),
    totalVotes: getTotalVotes(state),
    voteBox: getImage(state, "vote_box"),
    autoVote: getAutoVote(state),
    userId: getVotingUserId(state),
    donationId: getDonationId(state),
  };
};

const mapActionCreators = {
  nextPage,
  resetSearchFilters,
  setCurrentPage,
  setAutoVote,
  submitVotes,
};

export default connect(mapStateToProps, mapActionCreators)(ThankYou);
